module.exports = __webpack_public_path__ + "static/media/page-memberNotice2.fbebea25.jpg";